<div class="width100p height100p flex-col header">
    @if (isTableEditorPopup) {
        <div class="width100p flex-row flex-justify-end">
            <i class="m-2 fas fa-times mouse-pointer" (click)="close()"></i>
        </div>
    }
    <sm-form #formComponent class="width100p height100p" [style]="form.fields[0].style" [form]="form" [fullHeight]=true></sm-form>
</div>
